(ns ycweb.app.website.dlp.widgets.calloutpanel
  (:require
   [clojure.string :as str]
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc callout-panel < rum/reactive [app-atom _ {:keys [properties] :as widget}]
  (let [{:callout-panel/keys
         [on-page-link-id right-image graphic-type video-type
          video-embed-source image-url image-link-type image-border
          image-shadow image-split-2 image-split-3 picture-public-id
          image-alt-text button-text button-url button-link-type
          button-icon button-colour popup-1-title second-button-text
          second-button-url second-button-link-type popup-2-title title
          logo-public-id pre-title description description-format
          show-content? mute-widget? use-date-range? spacer
          spacer-size show-promo-banner-label? heading-type]} properties

        onpage? (= button-link-type "onpage")
        second-onpage? (= second-button-link-type "onpage")
        description? (trf/toboolean (u/presence description))]

    (when
      (and
        (not mute-widget?)
        show-content?)
      [:<>
       [:div.yc-section
        {:id (when on-page-link-id on-page-link-id)}
        [:article.flex-grid-group
         {:class (u/bem :callout-panel [(when right-image :hero-right)])}
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2 (when right-image :m-order-02)])}
          [:div.flex-grid-content
           [:div.callout-panel__hero
            (cond
              (= graphic-type "video")
              (cond
                (= video-type "iframe")
                [:div.video-wrapper.u-max-width-490
                 {:id (str "js-" (:uuid widget))}
                 [:iframe
                  (u/maybe assoc
                    {:src video-embed-source
                     :width "100%"
                     :height "250"
                     :frameborder 0
                     :allowfullscreen true}
                    :loading (when (u/presence image-shadow) "lazy")
                    :class (when (u/presence image-shadow) "yc-simple-image--shadow"))]]

                :else
                [:div.u-max-width-490.js-fitvid
                 {:class (when image-shadow "yc-simple-image--shadow")
                  :dangerouslySetInnerHTML
                  {:__html
                   (str "<script src='" video-embed-source "'></script>")}}])

              :else
              (let [image
                    (web-common/lazy-image app-atom picture-public-id
                      {:class
                       (u/bem :yc-simple-image
                         [:full
                          (when (u/presence image-shadow) :shadow)
                          (when (u/presence image-border) :border)])}
                      {:w 490
                       :mw 490
                       :q "auto"
                       :alt (if (u/presence image-alt-text) image-alt-text title)})]
                [:div.u-max-width-490
                 {:class
                  (when
                    (and
                      (u/presence image-border)
                      (or image-split-2 image-split-3))
                    (u/bem :yc-simple-image-wrapper
                      [(cond
                         image-split-3
                         :split-3

                         image-split-2
                         :split-2)]))}
                 (cond
                   (u/presence image-url)
                   [:a.u-block-link
                    (merge
                      (when (= (u/presence image-link-type) "onpage")
                        (urlstate/href-on-click #(scroll/scroll-to-id % image-url)))
                      {:href (if (= (u/presence image-link-type) "onpage") "#" image-url)})
                    image]

                   :else
                   image)]))
            (when show-promo-banner-label?
              [:div.callout-panel__label
               [:span
                {:class (u/bem :text-pill [:tiny :dark])}
                "Featured brand:"]])]]]
         [:div
          {:class (u/bem :flex-grid-block [:m-1-2])}
          [:div.flex-grid-content
           [:div.callout-panel__content
            (when (u/presence logo-public-id)
              [:div.callout-panel__logo-wrapper
               (web-common/lazy-image app-atom logo-public-id
                 {:class ["callout-panel__logo"]}
                 {:q "auto"
                  :alt (str "Logo for " title)})])
            (when (u/presence title)
              (headings/heading title
                (u/maybe assoc
                  {:type (keyword (str "h" heading-type))
                   :size :default
                   :dangerouslySetInnerHTML? true}
                  :pretext (u/presence pre-title))))
            (when description?
              (cond
                (= description-format "freeform")
                [:div
                 {:dangerouslySetInnerHTML
                  {:__html description}}]

                :else
                [:p.yc-paragraph
                 {:dangerouslySetInnerHTML
                  {:__html description}}]))
            (when (and (u/presence button-text) (u/presence button-url))
              (if (and (u/presence button-text) (u/presence second-button-text))
                [:div
                 {:class (u/bem :flex-grid-group [:align-left :flush-force])}
                 (when (and (u/presence second-button-text) (u/presence second-button-url))
                   [:div {:class (u/bem :flex-grid-block [:l-1-2])}
                    [:div.flex-grid-content
                     (buttons/button-web button-text
                       (merge
                         (when onpage?
                           (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace button-url #"\#" ""))))
                         {:href button-url
                          :style (if (= button-colour "dark") :primary :secondary)
                          :full (and (u/presence second-button-text) (u/presence second-button-url))
                          :class (when (= button-link-type "help") "js-mfp-open-url")
                          :icon (when-not (= button-icon "none") button-icon)
                          :custom-attrs
                          (when (u/presence popup-1-title)
                            {:target_url (str button-url "&overrideincludes=blank")
                             :data-title popup-1-title
                             :data-content-wrapper-class "yc-simple-text"})}))]])

                 [:div {:class (u/bem :flex-grid-block [:l-1-2])}
                  [:div.flex-grid-content
                   (buttons/button-web second-button-text
                     (merge
                       (when second-onpage?
                         (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace second-button-url #"\#" ""))))
                       {:href second-button-url
                        :on-click (when (= second-button-link-type "onpage") #(scroll/scroll-to-id % second-button-url))
                        :style :light
                        :full true
                        :class (when (= second-button-link-type "help") "js-mfp-open-url")
                        :custom-attrs
                        (when (u/presence popup-2-title)
                          {:target_url (str second-button-url "&overrideincludes=blank")
                           :data-title popup-2-title
                           :data-content-wrapper-class "yc-simple-text"})}))]]]

                (buttons/button-web button-text
                  (merge
                    (when onpage?
                      (urlstate/href-on-click #(scroll/scroll-to-id % (str/replace button-url #"\#" ""))))
                    {:href button-url
                     :style (if (= button-colour "dark") :primary :secondary)
                     :class (when (= button-link-type "help") "js-mfp-open-url")
                     :icon (when-not (= button-icon "none") button-icon)
                     :custom-attrs
                     (when (u/presence popup-1-title)
                       {:target_url (str button-url "&overrideincludes=blank")
                        :data-title popup-1-title
                        :data-content-wrapper-class "yc-simple-text"})}))))]]]]]
       (when (and spacer use-date-range?)
         [:div
          {:class (u/bem :dlp-spacer [(if (= spacer-size "medium") :medium :standard)])}])])))
